<mat-progress-bar [style.opacity]="visible ? '1' : '0'" color="orange" mode="indeterminate"></mat-progress-bar>
